import type { AgentRunStatus } from '@sbc/domain-models/gateway';

import { Badge } from '@/components/ui/badge';

const VARIANT: Record<AgentRunStatus, 'secondary' | 'default' | 'destructive' | 'outline'> = {
  queued: 'outline',
  running: 'default',
  done: 'secondary',
  exhausted: 'destructive',
};

export function RunStatusBadge({ status }: { status: AgentRunStatus }) {
  return <Badge variant={VARIANT[status]}>{status}</Badge>;
}
